<template>
    <b-modal size="sm" id="modal-set-odometer" centered hide-header hide-footer body-class="p-0" ref="modal-set-horometer">
        <div class="modal-header bg-primary d-flex justify-content-between">
            <div class="device-modal d-flex flex-row align-items-center">
                <img :src="require(`@/assets/img/devices/${icon}.png`)">
                <p class="text-light m-0 fs-4 ms-2">{{ plate }}</p>
            </div>
            <div class="close-modal d-flex" @click="close">
                <img src="@/assets/img/close.svg">
            </div>
        </div>
        <div class="d-flex flex-column p-3">
            <div class="item-setting d-flex flex-row align-items-end">
                <b-form-group class="p-1" id="input-group-1" label="Odómetro:" label-for="odometer">
                    <b-form-input id="horometer" v-model="formatedHorometer" type="number"></b-form-input>
                </b-form-group>
                <p class="m-0">H</p>
            </div>
            <b-button type="submit" variant="primary" class="mt-3" @click="$emit('updateHorometer', horometer)">Actualizar</b-button>
        </div>
    </b-modal>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
@Component({})
export default class SetHorometer extends Vue {

    horometer = 0
    icon = '0'
    plate = 'NaN'

    close() {
        const modal: any = this.$refs['modal-set-horometer']
        modal.hide();
    }

    show() {
        const modal: any = this.$refs['modal-set-horometer']
        modal.show();
    }

    get formatedHorometer() {
        return Number((this.horometer * (1 / 3600000)).toFixed(2))
    }

    set formatedHorometer(newVal: number) {
        this.horometer = newVal
    }

}
</script>

<style lang="sass">
    .item-setting
        p
            margin-bottom: 10px !important
            font-size: 18px
    .modal-header
        height: 60px !important
        img
            height: 45px

    .close-modal
        height: 20px
        cursor: pointer
        transition: all .1s ease
        &:active
            transform: scale(0.9)
            
        img
            height: 100%


</style>